
{
  "nav.startHere": "Начать здесь",
  "nav.about": "О нас",
  "nav.protocols": "Протоколы",
  "nav.tools": "Инструменты",
  "nav.compliance": "Соответствие",
  "nav.personal": "Личный протокол",
  "nav.organization": "Организационный протокол",
  "nav.mission": "Миссия и видение",
  "nav.scope": "Область применения и отказ от гарантий",
  "nav.standards": "Сопоставление стандартов",
  "nav.changelog": "Журнал изменений",
  "nav.governance": "Управление",
  "nav.disclaimer": "Правовая оговорка",
  "nav.contact": "Связаться с нами",
  
  "hero.title1": "Защитите свой",
  "hero.title2": "Цифровой мир",
  "hero.subtitle": "Глобальная платформа протокола кибербезопасности и готовности для частных лиц и организаций. Основана на отраслевых стандартах и глобальных структурах безопасности.",
  "hero.cta.start": "Начать оценку безопасности",
  "hero.cta.learn": "Узнать больше",
  "hero.trust.standards": "Соответствие стандартам",
  "hero.trust.standardsDesc": "Глобальные лучшие практики",
  "hero.trust.defensive": "Только защита",
  "hero.trust.defensiveDesc": "Этические рекомендации по безопасности",
  "hero.trust.global": "Глобальная платформа",
  "hero.trust.globalDesc": "Международные протоколы",
  
  "home.tab.personal": "Личный протокол",
  "home.tab.organization": "Организационный протокол",
  "home.personal.title": "Начните с этих 10 шагов",
  "home.personal.desc": "Основные средства контроля безопасности, которые каждый человек должен внедрить немедленно, чтобы предотвратить 90% распространенных атак.",
  "home.org.title": "Базовая безопасность организации",
  "home.org.desc": "Основные средства управления и технического контроля, которые каждая организация должна установить для снижения киберрисков и повышения устойчивости.",
  "home.org.note": "Эти шаги представляют собой минимальную базу, которую организации могут внедрить немедленно, независимо от размера или отрасли.",
  "home.principle1.title": "Глубокая защита",
  "home.principle1.titleOrg": "Многоуровневая безопасность",
  "home.principle1.desc": "Применяйте несколько независимых средств контроля безопасности, чтобы отказ одного средства контроля не поставил под угрозу общую безопасность.",
  "home.principle1.descOrg": "Несколько независимых средств контроля, так что если одно не сработает, другие останутся эффективными.",
  "home.principle2.title": "Мышление нулевого доверия",
  "home.principle2.titleOrg": "Непрерывная проверка",
  "home.principle2.desc": "Не полагайтесь на неявное доверие. Постоянно проверяйте доступ на основе идентификации, устройства и контекста.",
  "home.principle2.descOrg": "Проверяйте каждый запрос на доступ и всегда предполагайте потенциальную компрометацию.",
  "home.standards.badge": "Подход на основе стандартов",
  "home.standards.title": "Построено на глобальных стандартах безопасности",
  "home.standards.desc": "Наши протоколы строго соответствуют международно признанным структурам кибербезопасности и лучшим практикам.",
  "home.standards.risk.title": "Управление рисками",
  "home.standards.risk.desc": "Комплексный подход к управлению кибербезопасностью и операционной устойчивости на основе рисков.",
  "home.standards.risk.functions": "Управление, идентификация, защита, обнаружение, реагирование, восстановление",
  "home.standards.controls.title": "Средства контроля безопасности",
  "home.standards.controls.desc": "Международный стандарт для систем управления информационной безопасностью с комплексными средствами контроля.",
  "home.standards.controls.count": "114 средств контроля безопасности в 14 областях",
  "home.standards.practices.title": "Лучшие практики",
  "home.standards.practices.desc": "Приоритетные, действенные средства контроля безопасности для защиты от наиболее распространенных кибератак.",
  "home.standards.practices.count": "18 критических средств контроля безопасности",
  "home.standards.cta": "Просмотреть полное сопоставление стандартов",
  
  "footer.brand.desc": "Глобальная платформа протокола кибербезопасности и готовности для частных лиц и организаций.",
  "footer.brand.note": "Защитные рекомендации по безопасности, соответствующие стандартам.",
  "footer.protocols": "Протоколы",
  "footer.resources": "Ресурсы",
  "footer.about": "О нас",
  "footer.riskAssessment": "Оценка рисков",
  "footer.toolsLibrary": "Библиотека инструментов",
  "footer.complianceGuides": "Руководства по соответствию",
  "footer.standardsMapping": "Сопоставление стандартов",
  "footer.missionVision": "Миссия и видение",
  "footer.scopeDisclaimer": "Область применения и оговорка",
  "footer.contact": "Контакт",
  "footer.copyright": "CyberSecurityProtocol. Все права защищены.",
  "footer.educational": "Только образовательные и защитные рекомендации по кибербезопасности.",
  "footer.legal": "Правовая информация",
  "footer.nonGuarantee": "Отказ от гарантий",
  "footer.builtBy": "Создано UXER — Часть Ассоциации информационных технологий и открытого исходного кода (ATIOS)",
  
  "common.loading": "Загрузка...",
  "common.error": "Ошибка",
  "common.success": "Успех",
  "common.cancel": "Отмена",
  "common.save": "Сохранить",
  "common.continue": "Продолжить",
  "common.back": "Назад",
  "common.next": "Далее",
  "common.finish": "Завершить",
  "common.viewMore": "Просмотреть больше",
  "common.learnMore": "Узнать больше",
  "common.getStarted": "Начать"
}
